
// import React, { useEffect, useRef, useState } from "react";
// import {
//   Box, Button, Paper, Typography, Grid, TableContainer, Table,
//   TableHead, TableBody, IconButton, MenuItem, DialogActions,
//   DialogTitle, DialogContent, Dialog, TableRow, TableCell,
// } from "@mui/material";
// import ClearIcon from '@mui/icons-material/Clear';
// import { Html5Qrcode } from 'html5-qrcode';
// import { useLocation, useNavigate } from "react-router-dom";
// import { useForm } from "react-hook-form";
// import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
// import SaveIcon from "@mui/icons-material/Save";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import VerifiedIcon from "@mui/icons-material/Verified";
// import productMasterService from "../../../services/masters/productMaster.Service";
// import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
// import depotMasterService from "../../../services/masters/depotMaster.Service";
// import plantMasterService from "../../../services/masters/plantMaster.Service";
// import productionentryService from "../../../services/productionentry.Service";
// import qualitycontrolService from "../../../services/qualitycontrol.Service";
// import uploadFileApi from "../../../services/uploadFile.Service";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
// import { CTSinput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
// import operatorMasterService from "../../../services/masters/operatorMaster.Service";
// import styles from "../../../styles.module.css";
// import dayjs from "dayjs";
// import Snackbar from "@mui/material/Snackbar";
// import Alert from "@mui/material/Alert";

// // ── Styles ────────────────────────────────────────────────────────────────────

// const pageSx = {
//   background: "#F4F7FB", minHeight: "100vh",
//   padding: "20px 24px 40px", fontFamily: "'Inter', Arial, sans-serif",
// };
// const breadcrumbSx = {
//   fontSize: "12px", color: "#718096", mb: 2,
//   display: "flex", alignItems: "center", gap: "6px",
// };
// const pageHeaderSx = {
//   display: "flex", alignItems: "center",
//   justifyContent: "space-between", mb: 2.5,
// };
// const pageTitleSx = {
//   fontSize: "16px", fontWeight: 700, color: "#000",
//   display: "flex", alignItems: "center", gap: "10px",
// };
// const backBtnSx = {
//   display: "flex", alignItems: "center", gap: "6px",
//   fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
//   padding: "7px 14px", border: "1.5px solid #2B6CB0",
//   borderRadius: "7px", background: "#fff", textTransform: "none",
//   "&:hover": { background: "#E6F1FB" },
// };
// const formCardSx = {
//   background: "#fff",
//   border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
// };
// const sectionHeaderSx = {
//   background: "#1C3A5E", padding: "12px 22px",
//   display: "flex", alignItems: "center", gap: "10px",
// };
// const sectionHeaderTitleSx = {
//   fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
// };
// const formBodySx = { padding: "22px 24px" };
// const fieldLabelSx = {
//   fontSize: "12px", fontWeight: 600, color: "#2063b6",
//   mb: "4px", display: "flex", alignItems: "center", gap: "4px",
// };
// const inputSx = {
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa", height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//     "&.Mui-focused": { background: "#fff" },
//     "&.Mui-disabled": { background: "#F8FAFC" },
//   },
//   "& input": {
//     color: "#1A202C", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     "&::placeholder": { color: "#A0AEC0", opacity: 1 },
//   },
//   "& .MuiInputLabel-root": { display: "none" },
// };
// const readOnlyInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"], background: "#F0F4F8",
//   },
// };
// const datePickerSx = {
//   width: "100%",
//   "& .MuiOutlinedInput-root": {
//     borderRadius: "8px", fontSize: "13px",
//     fontFamily: "'Inter', Arial, sans-serif",
//     background: "#fafafa", height: "38px",
//     "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#CBD5E0" },
//     "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
//   },
//   "& input": { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" },
// };
// const formFooterSx = {
//   padding: "18px 24px", background: "#F8FAFC",
//   borderTop: "1px solid #E2E8F0",
//   display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px",
// };
// const saveBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#4CAF50",
//   color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
//   textTransform: "none", borderRadius: "8px",
//   "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
//   transition: "all 0.15s ease",
// };
// const cancelBtnSx = {
//   display: "flex", alignItems: "center", gap: "7px",
//   padding: "0 22px", height: "40px", background: "#E53E3E",
//   color: "#fff", border: "none", textTransform: "none",
//   "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
//   fontSize: "14px", fontWeight: 600, borderRadius: "8px",
// };
// const tableHeadCellSx = {
//   background: "#1C3A5E !important", color: "#fff !important",
//   fontSize: "12px", fontWeight: 600,
//   fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap",
// };

// const topupInputSx = {
//   ...inputSx,
//   "& .MuiOutlinedInput-root": {
//     ...inputSx["& .MuiOutlinedInput-root"],
//       borderRadius: 0, 
//     background: "#f5bb32",                    // ✅ light yellow highlight
//     "& fieldset": { borderColor: "#F0B429", borderWidth: "1.5px" },
//     "&:hover fieldset": { borderColor: "#D69E2E" },
//     "&.Mui-focused fieldset": { borderColor: "#D69E2E", borderWidth: "2px" },
//      "&.Mui-focused": { background: "#F5bb32" }, 
//   },
//   "& input": {
//     ...inputSx["& input"],
//     color: "#000000",           // ✅ NEW — full black text
//     fontWeight: 600,
//   },
// };

// // ─────────────────────────────────────────────────────────────────────────────

// const QualityEntryAdd = () => {
//   const login_details = sessionStorage.getItem('loginUser');
//   const userD = JSON.parse(login_details);
//   const userInfo = userD.result.userInfo;
//   const user_role = userD?.result?.userInfo?.user_role;
//   const plant_id = userInfo.plant_id;
//   const unit_id = userInfo.depot_id || userInfo.plant_id;
//   const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
//   const depot_id = userInfo.assigned_depot_id;

//   const { handleSubmit } = useForm();
//   const urlLocation = useLocation();
//   const editInfo = urlLocation.state;
//   const editData = editInfo && editInfo;
//   const editid = editData ? editData.quality_control_id : null;
//   let navigate = useNavigate();

//   const [data, setData] = useState({
//     entry_no: editData ? editData.entry_no : "",
//     quality_supervisor: editData ? editData.quality_supervisor : userInfo.plant_name || "",
//     batch_no: editData ? editData.batch_no : "",
//       topup_qty: editData ? editData.topup_qty : "",
//     prod_code: editData ? editData.prod_code : "",
//     prod_id: editData ? editData.prod_id : "",
//     prod_description: editData ? editData.prod_description : "",
//     from_plant: editData ? editData.from_plant : "",
//     to_depot_id: editData ? editData.to_depot_id : depot_id,
//     entry_date: editData?.entry_date
//       ? new Date(editData.entry_date).toISOString().split("T")[0]
//       : new Date().toISOString().split("T")[0],
//     fin_year: editData ? editData.fin_year : "",
//     from_plant_id: editData ? editData.from_plant_id || plant_id : plant_id,
//     to_plant_id: editData ? editData.to_plant_id || plant_id : plant_id,
//     modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     modified_by: editData ? userInfo.user_id : null,
//     created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
//     created_by: editData ? editData.created_by : userInfo.user_id,
//   });

//   const [product, setProduct] = useState([]);
//   const [cylinder, setCylinder] = useState([]);
//   const [selectedFile, setSelectedFile] = useState(null);
//   const [plant, setPlant] = useState([]);
//   const [depot, setDepot] = useState([]);
//   const [production_entry, setProductionEntry] = useState([]);
//   const [relatedCylinders, setRelatedCylinders] = useState([]);
//   const [operatorList, setOperatorList] = useState([]);
//   const [table_details, setQualityDetails] = useState(
//     editData && editData.table_details && Array.isArray(JSON.parse(editData.table_details))
//       ? JSON.parse(editData.table_details) : []
//   );
//   const [openDialog, setOpenDialog] = useState(false);
//   const [isMultiDialog, setIsMultiDialog] = useState(false);
//   const [dialogData, setDialogData] = useState({
//     cyl_no: "", cyl_id: "", tag_no: "", owner: "",qty_filled: "",
//     product_purity: "", settled_pressure: "",topup_qty: "", 
//     leak_test: "Ok", quality_result: "Ok", remarks: "", filePath: "",
//   });
//   const [multiCylinders, setMultiCylinders] = useState([]);
//   const [editIndex, setEditIndex] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [openSnackbar, setOpenSnackbar] = useState(false);
//   const [severity, setSeverity] = useState("info");
//   const [isScannerOpen, setIsScannerOpen] = useState(false);
//   const [scanResults, setScanResults] = useState([]);
//   const [batchNo, setbatchno] = useState([]);
//   const qrCodeRegionId = 'qr-reader';
//   const html5QrCodeRef = useRef(null);
//   const scannerStateRef = useRef({ isStarting: false, isStopping: false });
//   const lastScanTimeRef = useRef(0);
//   const debounceDelay = 500;

//   const handleCloseDialog = () => {
//     stopScanner(); setOpenDialog(false); setScanResults([]);
//   };

//   useEffect(() => {
//     async function fetchData() {
//       try {
//         const [productData, cylinderData, depotData, plantData, productionEntryData, batchData, relatedCylindersData, operatorData] = await Promise.all([
          
//           productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
//           cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
//           depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
//           plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
//           productionentryService.getProductionEntryList({ page: 0, size: 999, searchKey: "" }),
//           qualitycontrolService.getBatchNo({ page: 0, size: 999, searchKey: "" }),
//           data.batch_no ? qualitycontrolService.getQualityCylinder(plant_id, data.batch_no) : Promise.resolve([]),
//            operatorMasterService.getOperatorList({ page: 0, size: 999, searchKey: "" }),
          
//         ]);
//         setProduct(productData); setCylinder(cylinderData); setDepot(depotData);
//         setPlant(plantData); setProductionEntry(productionEntryData);
//         setRelatedCylinders(relatedCylindersData);
//         setOperatorList(Array.isArray(operatorData) ? operatorData : []);
//         setbatchno(Array.isArray(batchData) ? batchData : (Array.isArray(batchData?.data) ? batchData.data : []));
//         if (!editData) {
//   const qualityList = await qualitycontrolService.getQualitycontrolList({ page: 0, size: 5, searchKey: "" });
  
//   const lastEntryNo = qualityList?.[0]?.entry_no ?? "";
//   const parts = String(lastEntryNo).split("/");
//   const lastSeq = parseInt(parts[parts.length - 1]) || 0;
//   const nextSeq = lastSeq + 1;

//   // Short year: "26-27"
//   const yr = dayjs();
//   const finYear = yr.month() >= 3
//     ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
//     : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;


//   const formattedEntryNo = `QC/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

//   setData(prev => ({
//     ...prev,
//     entry_no: formattedEntryNo,
//     fin_year: finYear,
//   }));
// }
//       } catch (error) { console.error("Data fetching failed", error); }
//     }
//     fetchData();
//   }, [plant_id, data.batch_no]);

//   useEffect(() => {
//     if (editData && product.length && editData.prod_id) {
//       const foundProduct = product.find((p) => p.prod_id === editData.prod_id);
//       let update = {};
//       if (foundProduct) { update.prod_code = foundProduct.prod_code; update.prod_description = foundProduct.prod_description; }
//       if (editData.from_plant_id && plant.length) {
//         const foundPlant = plant.find((p) => p.plant_id === editData.from_plant_id);
//         if (foundPlant) { update.from_plant = foundPlant.plant_id; update.quality_supervisor = foundPlant.plant_name; }
//       }
//       if (Object.keys(update).length > 0) setData((prev) => ({ ...prev, ...update }));
//     } else {
//       setData((prev) => ({ ...prev, quality_supervisor: userInfo.plant_name || prev.quality_supervisor }));
//     }
//   }, [editData, product, plant, userInfo.plant_name]);

//   useEffect(() => {
//     if (data.batch_no && relatedCylinders.length > 0) {
//       setQualityDetails(relatedCylinders.map((cyl, index) => ({
//         sr_no: index + 1, cyl_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "",
//         tag_no: cyl.tag_no || "", owner: cyl.owner || "N/A", product_purity: "",  qty_filled: cyl.qty_filled ?? "",
//         settled_pressure: cyl.batch_pressure || "", leak_test: "Ok", quality_result: "Ok", remarks: "", filePath: "",
//       })));
//     }
//   }, [relatedCylinders, data.batch_no]);

//   useEffect(() => {
//   const total = table_details
//     .filter(row => parseFloat(row.topup_qty) > 0)
//     .reduce((sum, row) => sum + parseFloat(row.topup_qty), 0);
//   setData(prev => ({ ...prev, topup_qty: total > 0 ? total.toFixed(2) : "" }));
// }, [table_details]);

//   const handleChange = ({ target }) => {
//     const { name, value } = target;
//     if (name === "batch_no") {
//       const selectedBatch = batchNo.find(pe => pe.batch_no === value);
//       let prod_id = selectedBatch?.prod_id || "";
//       let prod_code = "", prod_description = "";
//       if (prod_id && product.length) {
//         const found = product.find((p) => p.prod_id === prod_id);
//         if (found) { prod_code = found.prod_code; prod_description = found.prod_description; }
//       }
//       setData({ ...data, batch_no: value, prod_id, prod_code, prod_description });
//     } else {
//       setData(prevData => {
//         const updatedData = { ...prevData, [name]: value };
//         if (name === "entry_date" && value) {
//           const d = new Date(value);
//           if (!isNaN(d.getTime())) {
//             const m = d.getMonth(), y = d.getFullYear();
//             updatedData.fin_year = m >= 3 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
//           }
//         }
//         return updatedData;
//       });
//     }
//   };

//   const findRelatedCylinderByNoOrTag = (input) => {
//     if (!input) return null;
//     const val = input.trim().toLowerCase();
//     return relatedCylinders.find(cyl =>
//       (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
//       (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
//     );
//   };

//   const handleSingleCylinderInput = (input) => {
//     const match = findRelatedCylinderByNoOrTag(input);
//     if (match) {
//       setDialogData({ cyl_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, owner: match.cust_name || match.owner || '', qty_filled: match.qty_filled ?? '', product_purity: dialogData.product_purity || '', settled_pressure: dialogData.settled_pressure || '', leak_test: dialogData.leak_test || 'Ok', quality_result: dialogData.quality_result || 'Ok', remarks: dialogData.remarks || '', filePath: dialogData.filePath || '' });
//       setSuccessMessage(`Cylinder ${match.cylinder_no} loaded successfully`); setOpenSnackbar(true);
//     } else {
//       setDialogData(prev => ({ ...prev, cyl_no: '', cyl_id: '', tag_no: '', owner: '', filePath: '' }));
//       setSuccessMessage('No cylinder found'); setOpenSnackbar(true);
//     }
//   };

//   const handleMultiCylinderInput = (input) => {
//     const match = findRelatedCylinderByNoOrTag(input);
//     if (match) {
//       if (multiCylinders.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage(`Already added`); setOpenSnackbar(true); return; }
//       setMultiCylinders(prev => [...prev, { cyl_id: match.cyl_id, cylinder_no: match.cylinder_no, tag_no: match.tag_no, owner: match.cust_name || match.owner || '',qty_filled: match.qty_filled ?? ''  }]);
//       setSuccessMessage(`Added successfully`); setOpenSnackbar(true);
//     } else { setSuccessMessage('No cylinder found'); setOpenSnackbar(true); }
//   };

//   const handleOpenDialog = () => {
//     setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '',leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
//     setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleOpenmulDialog = () => {
//     setMultiCylinders([]);
//     setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '', leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
//     setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
//   };

//   const uploadFile = async (file, cylId) => {
//     if (!(file instanceof File)) throw new Error('Invalid file object');
//     const formData = new FormData();
//     formData.append('file', file);
//     formData.append('filename', cylId ? `${cylId}_${Date.now()}_${file.name}` : `${Date.now()}_${file.name}`);
//     formData.append('cyl_id', cylId);
//     const result = await uploadFileApi.uploadFile(formData);
//     if (!result.filePath) throw new Error('Server did not return a file path');
//     return result.filePath;
//   };

//   const handleFileUpload = async (event) => {
//     const file = event.target.files[0];
//     if (!file) return;
//     const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
//     if (!allowedTypes.includes(file.type)) { setSuccessMessage('Invalid file type.'); setOpenSnackbar(true); return; }
//     if (file.size > 5 * 1024 * 1024) { setSuccessMessage('File size exceeds 5MB.'); setOpenSnackbar(true); return; }
//     try {
//       setSuccessMessage('Uploading...'); setOpenSnackbar(true);
//       const filePath = await uploadFile(file, dialogData.cyl_id || '');
//       setDialogData((prev) => ({ ...prev, filePath }));
//       setSelectedFile({ name: file.name, path: filePath });
//       setSuccessMessage('File uploaded successfully'); setOpenSnackbar(true);
//     } catch (error) { setSuccessMessage(`Upload error: ${error.message}`); setOpenSnackbar(true); }
//   };

// const handleDialogSubmit = async () => {
//   try {
//     if (isMultiDialog) {
//       if (multiCylinders.length === 0) { 
//         setSuccessMessage('Add at least one cylinder'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return; 
//       }

//       // ✅ Product Purity mandatory check (multi)
//       if (!dialogData.product_purity || dialogData.product_purity.toString().trim() === "") {
//         setSuccessMessage('Product Purity is required'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return;
//       }

//       const newRows = await Promise.all(multiCylinders.map(async (cyl, idx) => {
//         if (table_details.some((row) => row.cyl_id === cyl.cyl_id)) return null;
//         return {
//           sr_no: table_details.length + idx + 1,
//           cyl_no: cyl.cylinder_no,
//           cyl_id: cyl.cyl_id,
//           tag_no: cyl.tag_no,
//           owner: cyl.owner,
//            qty_filled: cyl.qty_filled ?? '',
//           product_purity: dialogData.product_purity || '',
//           settled_pressure: cyl.batch_pressure || dialogData.settled_pressure || '',
//           topup_qty: dialogData.topup_qty !== "" && !isNaN(parseFloat(dialogData.topup_qty))
//             ? parseFloat(dialogData.topup_qty).toFixed(2)
//             : "",
//           leak_test: dialogData.leak_test || 'Ok',
//           quality_result: dialogData.quality_result || 'Ok',
//           remarks: dialogData.remarks || '',
//           filePath: dialogData.filePath || ''
//         };
//       }));
//       const validRows = newRows.filter((row) => row !== null);
//       if (validRows.length === 0) { 
//         setSuccessMessage('All cylinders already added'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return; 
//       }
//       setQualityDetails((prev) => [...prev, ...validRows]);
//       setSuccessMessage('Cylinders added successfully');
//       setSeverity("success");
//       setOpenSnackbar(true);
//     } else {
//       if (!dialogData.cyl_id) { 
//         setSuccessMessage('No valid cylinder loaded'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return; 
//       }

//       // ✅ Product Purity mandatory check (single)
//       if (!dialogData.product_purity || dialogData.product_purity.toString().trim() === "") {
//         setSuccessMessage('Product Purity is required'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return;
//       }

//       const newRow = {
//         sr_no: editIndex !== null ? table_details[editIndex].sr_no : table_details.length + 1,
//         cyl_no: dialogData.cyl_no,
//         cyl_id: dialogData.cyl_id,
//         tag_no: dialogData.tag_no,
//         owner: dialogData.owner,
//          qty_filled: dialogData.qty_filled ?? '',
//         product_purity: dialogData.product_purity || '',
//         settled_pressure: dialogData.settled_pressure || '',
//         topup_qty: dialogData.topup_qty !== "" && !isNaN(parseFloat(dialogData.topup_qty))   // ✅ ADDED — ye missing tha
//           ? parseFloat(dialogData.topup_qty).toFixed(2)
//           : "",
//         leak_test: dialogData.leak_test || 'Ok',
//         quality_result: dialogData.quality_result || 'Ok',
//         remarks: dialogData.remarks || '',
//         filePath: dialogData.filePath || ''
//       };
      
//       let wasDuplicate = false;
//       setQualityDetails((prev) => {
//         if (editIndex !== null) { const updated = [...prev]; updated[editIndex] = newRow; return updated; }
//         if (prev.some((row) => row.cyl_id === newRow.cyl_id)) { 
//           wasDuplicate = true;
//           return prev; 
//         }
//         return [...prev, newRow];
//       });

//       if (wasDuplicate) {
//         setSuccessMessage('Already added'); 
//         setSeverity("error");
//         setOpenSnackbar(true); 
//         return;
//       }
//       // setSuccessMessage(editIndex !== null ? 'Cylinder updated successfully' : 'Cylinder added successfully');
//       // setSeverity("success");
//       // setOpenSnackbar(true);
//     }
//     setOpenDialog(false); setScanResults([]); setEditIndex(null); setMultiCylinders([]);
//     stopScanner(); setSelectedFile(null);
//     setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '', leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
//   } catch (error) { 
//     setSuccessMessage(`Error: ${error.message}`); 
//     setSeverity("error");
//     setOpenSnackbar(true); 
//   }
// };

//   const handleDialogChange = ({ target }) => {
//     const { name, value } = target;
//     setDialogData(prev => ({ ...prev, [name]: value }));
//   };

//    const handleEditRow = (index) => {
//     const row = table_details[index];
//     setDialogData({ cyl_no: row.cyl_no || '', cyl_id: row.cyl_id || '', tag_no: row.tag_no || '', owner: row.owner || '', qty_filled: row.qty_filled || '', product_purity: row.product_purity || '', settled_pressure: row.settled_pressure || '',topup_qty: row.topup_qty || '', leak_test: row.leak_test || 'Ok', quality_result: row.quality_result || 'Ok', remarks: row.remarks || '', filePath: row.filePath || '' });
//     setSelectedFile(row.filePath ? { name: row.filePath.split('/').pop(), path: row.filePath } : null);
//     setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
//   };

//   const handleRemoveRow = (index) => {
//     setQualityDetails(prev => prev.filter((_, i) => i !== index));
//   };

//   const stopScanner = () => {
//     if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
//     if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
//     scannerStateRef.current.isStopping = true;
//     html5QrCodeRef.current.stop().then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
//   };

//   useEffect(() => {
//     if (!isScannerOpen || !openDialog) {
//       if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) stopScanner();
//       return;
//     }
//     const element = document.getElementById(qrCodeRegionId);
//     if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
//     if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) { scannerStateRef.current.isStarting = false; return; }
//     html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
//     html5QrCodeRef.current.start({ facingMode: 'environment' }, { fps: 10, qrbox: 250 },
//       (decodedText) => {
//         const now = Date.now();
//         if (now - lastScanTimeRef.current < debounceDelay) return;
//         lastScanTimeRef.current = now;
//         if (scanResults.includes(decodedText)) return;
//         const match = findRelatedCylinderByNoOrTag(decodedText);
//         if (match) {
//           if (isMultiDialog) handleMultiCylinderInput(decodedText);
//           else { handleSingleCylinderInput(decodedText); stopScanner(); }
//           setScanResults(prev => [...prev, decodedText]);
//         }
//       }, () => { }
//     ).then(() => { scannerStateRef.current.isStarting = false; })
//       .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
//     return () => {
//       if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning && !scannerStateRef.current.isStopping) {
//         try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch (err) { }
//       }
//     };
//   }, [isScannerOpen, openDialog, isMultiDialog]);

//   // const onSubmit = async () => {
//   //   if (!table_details || table_details.length === 0) { setSuccessMessage("Add at least one cylinder."); setOpenSnackbar(true); return; }
//   //   const quality_Data = { ...data, quality_control_id: editid, table_details: JSON.stringify(table_details), changedUpdatedValue: "edit", unit_id, short_code };
//   //   try {
//   //     if (editData) { await qualitycontrolService.editDeleteQualitycontrol(quality_Data); setSuccessMessage("Updated successfully"); }
//   //     else { await qualitycontrolService.addQualitycontrol(quality_Data); setSuccessMessage("Added successfully"); }
//   //     setOpenSnackbar(true);
//   //     setTimeout(() => navigate(-1), 1000);
//   //   } catch (error) { setSuccessMessage(`Error: ${error.message}`); setOpenSnackbar(true); }
//   // };

// const [isSubmitting, setIsSubmitting] = useState(false);

// const onSubmit = async () => {
//   if (isSubmitting) return;

//   // 👇 Quality Supervisor required — is ke bina save nahi hoga
//   if (!data.quality_supervisor || data.quality_supervisor.toString().trim() === "") {
//     setSuccessMessage("Please select Quality Supervisor before saving.");
//     setSeverity("error");
//     setOpenSnackbar(true);
//     return;
//   }

//   if (!table_details || table_details.length === 0) {
//     setSuccessMessage("Add at least one cylinder."); 
//     setSeverity("error");
//     setOpenSnackbar(true); 
//     return; 
//   }

//   // 👇 NAYI LINE — sirf wahi rows lo jinka product_purity bhara hai
// // 👇 NAYI LINE — sirf wahi rows lo jinka product_purity bhara hai
//   const table_details_filtered = table_details.filter(
//     row => row.product_purity && row.product_purity.toString().trim() !== ""
//   );

//   // Agar kisi bhi row mein Product Purity nahi hai, toh save hi mat hone do
//   if (table_details_filtered.length === 0) {
//     setSuccessMessage("Please enter Product Purity for at least one cylinder before saving.");
//     setSeverity("error");
//     setOpenSnackbar(true);
//     return;
//   }

//    setIsSubmitting(true);
//   const quality_Data = {
//     ...data, 
//     quality_control_id: editid,
//     table_details: JSON.stringify(table_details_filtered), // 👈 YAHAN table_details ko table_details_filtered kiya
//     changedUpdatedValue: "edit", 
//     unit_id, 
//     short_code 
//   };
//   try {
//     if (editData) { 
//       await qualitycontrolService.editDeleteQualitycontrol(quality_Data); 
//       setSuccessMessage("Updated successfully"); 
//       setSeverity("success");
//     } else { 
//       await qualitycontrolService.addQualitycontrol(quality_Data); 
//       setSuccessMessage("Added successfully"); 
//       setSeverity("success");
//     }
//     setOpenSnackbar(true);
//      setTimeout(() => navigate("/productionEntries/list-qe"), 1000); 
//   } catch (error) { 
//     setSuccessMessage(`Error: ${error.message}`); 
//     setSeverity("error");
//     setOpenSnackbar(true); 
//     setIsSubmitting(false);
//   }
// };
//   const getConditionalStyles = (value) => ({
//     '& .MuiSelect-select': { color: value === 'Ok' ? 'green' : value === 'Not Ok' ? '#c52525' : 'inherit' },
//     '& .MuiOutlinedInput-notchedOutline': { borderColor: value === 'Ok' ? 'green' : value === 'Not Ok' ? '#c52525' : 'inherit' },
//   });

//   return (
//     <LocalizationProvider dateAdapter={AdapterDayjs}>
//       <Box sx={pageSx}>

//         {/* Breadcrumb */}
//         <Box sx={breadcrumbSx}>
//           <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Quality Entry</span>
//         </Box>

//         {/* Page Header */}
//         <Box sx={pageHeaderSx}>
//           <Box sx={pageTitleSx}>
//             <VerifiedIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
//             {editData ? "UPDATE" : "ADD"} QUALITY ENTRY
//           </Box>
//           <Button onClick={() => navigate(-1)} sx={backBtnSx}>
//             <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
//           </Button>
//         </Box>

//         <form onSubmit={handleSubmit(onSubmit)}>

//           {/* ── Section 1: Entry Details ── */}
//           <Box sx={formCardSx}>
//             <Box sx={sectionHeaderSx}>
//               <VerifiedIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Quality Entry Details</Typography>
//             </Box>
//             <Box sx={formBodySx}>
//   <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

//     {/* LEFT — blank */}
//     {/* LEFT — Topup Qty */}
// <Grid item xs={12} md={6} sx={{
//   p: 2.5,
//   borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
//   minHeight: 200,
// }}>
//   <Grid container spacing={1.5}>
//     <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>Total Topup Qty</Typography>
//   <CTSinput
//     type="number"
//     size="small"
//     fullWidth
//     name="topup_qty"
//     value={data.topup_qty}
//     sx={topupInputSx}
//     InputProps={{ 
//       readOnly: true,
//       className: styles.CTSinput_Box,
//       style: { fontWeight: 600 }
//     }}
//     // placeholder="Auto-calculated from cylinders"
//   />
// </Grid>
//   </Grid>
// </Grid>

//     {/* RIGHT — all fields */}
//     <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
//       <Grid container spacing={1.5}>

//         {/* Entry No */}
//     <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>Entry No</Typography>
//   <CTSinput size="small" fullWidth value={data.entry_no} variant="outlined"
//     InputProps={{ 
//       readOnly: true, 
//       className: styles.CTSinput_Box, 
//       style: { backgroundColor: "#F0F4F8", fontSize: "13px" } 
//     }}
//   />
// </Grid>

//         {/* Entry Date */}
//         <Grid item xs={12} sm={6}>
//           <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
//           <DatePicker format="DD/MM/YYYY"
//             value={data.entry_date ? dayjs(data.entry_date) : null}
//             onChange={(newValue) => handleChange({ target: { name: "entry_date", value: newValue ? newValue.format("YYYY-MM-DD") : "" } })}
//             sx={datePickerSx}
//             slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
//           />
//         </Grid>

//         {/* Batch No */}
//         <Grid item xs={12} sm={6}>
//           <Typography sx={fieldLabelSx}>Batch No</Typography>
//           <CTSinput select size="small" fullWidth value={data.batch_no}
//             onChange={handleChange} name="batch_no"
//             InputProps={{ className: styles.CTSinput_Box }}
//           >
//             {/* <MenuItem value="" disabled>Select Batch No</MenuItem> */}
//             {batchNo.map(entry => (
//               <MenuItem key={entry.batch_no} value={entry.batch_no} className={styles.cts_lable}>
//                 {entry.batch_no}
//               </MenuItem>
//             ))}
//           </CTSinput>
//         </Grid>

//         {/* Quality Supervisor */}
//     <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>
//     Quality Supervisor <span style={{ color: "#c52525" }}>*</span>
//   </Typography>
//   <CTSinput
//     select
//     size="small"
//     fullWidth
//     required
//     name="quality_supervisor"
//     value={data.quality_supervisor || ""}
//     onChange={handleChange}
//     error={!data.quality_supervisor}
//     InputProps={{ className: styles.CTSinput_Box }}
//   >
//     {/* <MenuItem value="" disabled>
//       <em style={{ color: "#A0AEC0" }}>Select Supervisor</em>
//     </MenuItem> */}
//     {operatorList.map((op) => (
//       <MenuItem
//         key={op.operator_id}
//         value={op.operator_name}
//         className={styles.cts_lable}
//       >
//         {op.operator_name}
//       </MenuItem>
//     ))}
//   </CTSinput>
// </Grid>

//       </Grid>
//     </Grid>

//   </Grid>
// </Box>
//           </Box>

//           {/* ── Section 2: Cylinder Table ── */}
//           <Box sx={formCardSx}>
//             {/* <Box sx={sectionHeaderSx}>
//               <VerifiedIcon sx={{ fontSize: 18, color: "#fff" }} />
//               <Typography sx={sectionHeaderTitleSx}>Cylinder Details</Typography>
//             </Box> */}

//             <Paper sx={{ width: '100%', boxShadow: "none" }}>
//               <TableContainer component={Paper} sx={{ boxShadow: "none", borderRadius: 0 }}>
//                 <Table size="small" stickyHeader>
//                   <TableHead>
//                     <StyledTableRow>
//                       {["Sr No", "Cyl No", "Tag No", "Owner", "Product Purity", "Settled Pressure","Leak Test", "Quality Result","Qty Filled", "Remarks", "File","Topup Qty","Action"].map((h, i) => (
//                         <StyledTableCell key={i} align={i === 0 || i === 10 ? "center" : "left"} sx={tableHeadCellSx}>{h}</StyledTableCell>
//                       ))}
//                     </StyledTableRow>
//                   </TableHead>
//                   <TableBody sx={{ backgroundColor: '#fff' }}>
//                     {table_details?.map((row, index) => (
//                       <StyledTableRow key={row.cyl_id || index} onClick={() => handleEditRow(index)} sx={{ cursor: 'pointer', "&:hover": { background: "#F0F4F8" } }}>
//                         <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{index + 1}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.cyl_no}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.tag_no}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.owner || 'N/A'}</StyledTableCell>
                          
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.product_purity}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.settled_pressure}</StyledTableCell>

//                         <StyledTableCell align="left" sx={{ fontSize: "12px", color: row.leak_test === 'Ok' ? 'green' : '#c52525', fontWeight: 600 }}>{row.leak_test}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px", color: row.quality_result === 'Ok' ? 'green' : '#c52525', fontWeight: 600 }}>{row.quality_result}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.qty_filled || '-'}</StyledTableCell>
//                         <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.remarks}</StyledTableCell>
// <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.filePath ? row.filePath.split('/').pop() : 'None'}</StyledTableCell>
// <StyledTableCell align="center" sx={{ 
//   fontSize: "12px", 
//   fontWeight: 600, 
 
 
// }}>
//   {row.topup_qty && parseFloat(row.topup_qty) > 0 ? parseFloat(row.topup_qty).toFixed(2) : 0}
// </StyledTableCell>
// <StyledTableCell align="center" onClick={e => e.stopPropagation()}>
//   <IconButton size="small" onClick={() => handleRemoveRow(index)}>
//     <DeleteForeverIcon sx={{ fontSize: "18px", color: "#E53E3E" }} />
//   </IconButton>
// </StyledTableCell>
//                       </StyledTableRow>
//                     ))}
//                     {(!table_details || table_details.length === 0) && (
//                       <StyledTableRow>
//                         <StyledTableCell colSpan={13} align="center" sx={{ fontSize: "12px", color: "#718096", py: 3 }}>
//                           No cylinders added — select a batch to auto-populate
//                         </StyledTableCell>
//                       </StyledTableRow>
//                     )}
//                   </TableBody>
//                 </Table>
//               </TableContainer>
//             </Paper>

//             {/* Footer */}
//             <Box sx={formFooterSx}>
//               <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
//                 <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
//                 <SaveIcon sx={{ fontSize: 18 }} />
//                 {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
//               </Button>
//             </Box>
//           </Box>

//         </form>

//         {/* ── Dialog ── */}
//         <Dialog open={openDialog} onClose={() => { stopScanner(); setOpenDialog(false); setScanResults([]); setEditIndex(null); }} maxWidth="md" fullWidth
//           PaperProps={{ sx: { borderRadius: "14px" } }}>
//           <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 }}>
//             {editIndex !== null ? (
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
//                 <Typography sx={{ color: "#fff", fontSize: "13px" }}>Cylinder No: {dialogData.cyl_no || 'N/A'}</Typography>
//                 <Typography sx={{ color: "#fff", fontSize: "13px" }}>Tag No: {dialogData.tag_no || 'N/A'}</Typography>
//                 <Typography sx={{ color: "#fff", fontSize: "13px" }}>Owner: {dialogData.owner || 'N/A'}</Typography>
//               </Box>
//             ) : isMultiDialog ? 'Scan Multiple Cylinders' : 'Scan Single Cylinder'}
//           </DialogTitle>
//           <DialogContent sx={{ pt: 2 }}>
//             <Grid container spacing={2} sx={{ pt: 2, justifyContent: 'space-between' }}>
//               {isMultiDialog ? (
//                 <Box sx={{ mt: 2, width: "100%" }}>
//                   <TableContainer component={Paper}>
//                     <Table size="small">
//                       <TableHead>
//                         <TableRow>
//                           {["Sr No", "Owner", "Cylinder No", "Tag No", "Action"].map((h, i) => (
//                             <TableCell key={i} sx={{ fontWeight: 700, background: "#1C3A5E", color: "#fff", fontSize: "12px" }}>{h}</TableCell>
//                           ))}
//                         </TableRow>
//                       </TableHead>
//                       <TableBody>
//                         {multiCylinders.map((row, idx) => (
//                           <TableRow key={row.cyl_id}>
//                             <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
//                             <TableCell sx={{ fontSize: "12px" }}>{row.owner || 'N/A'}</TableCell>
//                             <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
//                             <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
//                             <TableCell>
//                               <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))}>
//                                 <DeleteForeverIcon sx={{ fontSize: '18px', color: '#E53E3E' }} />
//                               </IconButton>
//                             </TableCell>
//                           </TableRow>
//                         ))}
//                       </TableBody>
//                     </Table>
//                   </TableContainer>
//                 </Box>
//               ) : (
//                 <Grid container spacing={2} sx={{ mt: 1, pb: 1, px: 1 }}>
//                   <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>Product Purity <span style={{ color: "#E53E3E" }}>*</span></Typography>
//   <CTSinput type="number" fullWidth size="small" name="product_purity"
//     value={dialogData.product_purity} onChange={handleDialogChange}
//     InputProps={{ className: styles.CTSinput_Box2 }}
//     error={!dialogData.product_purity}
//   />
// </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Settled Pressure</Typography>
//                     <CTSinput type="number" fullWidth size="small" name="settled_pressure"
//                       value={dialogData.settled_pressure} onChange={handleDialogChange}
//                       InputProps={{ className: styles.CTSinput_Box2 }}
//                     />
//                   </Grid>
                  
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Leak Test</Typography>
//                     <CTSinput select size="small" fullWidth name="leak_test"
//                       value={dialogData.leak_test} onChange={handleDialogChange}
//                       sx={getConditionalStyles(dialogData.leak_test)}
//                       InputProps={{ className: styles.CTSinput_Box2 }}
//                     >
//                       <MenuItem value="Ok" sx={{ color: 'green', fontSize: "13px" }}>Ok</MenuItem>
//                       <MenuItem value="Not Ok" sx={{ color: 'red', fontSize: "13px" }}>Not Ok</MenuItem>
//                     </CTSinput>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Quality Result</Typography>
//                     <CTSinput select size="small" fullWidth name="quality_result"
//                       value={dialogData.quality_result} onChange={handleDialogChange}
//                       sx={getConditionalStyles(dialogData.quality_result)}
//                       InputProps={{ className: styles.CTSinput_Box2 }}
//                     >
//                       <MenuItem value="Ok" sx={{ color: 'green', fontSize: "13px" }}>Ok</MenuItem>
//                       <MenuItem value="Not Ok" sx={{ color: 'red', fontSize: "13px" }}>Not Ok</MenuItem>
//                     </CTSinput>
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Upload File</Typography>
//                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
//                       <CTSinput size="small" fullWidth value={selectedFile ? selectedFile.name : ''} placeholder="No file chosen"
//                         InputProps={{ className: styles.CTSinput_Box2, readOnly: true, endAdornment: selectedFile ? (
//                           <IconButton size="small" onClick={() => { setSelectedFile(null); setDialogData(prev => ({ ...prev, filePath: '' })); }} sx={{ color: 'red' }}>
//                             <ClearIcon fontSize="small" />
//                           </IconButton>
//                         ) : null }}
//                         sx={{ maxWidth: 260 }}
//                       />
//                       <Button variant="contained" component="label" size="small"
//                         sx={{ minWidth: 120, backgroundColor: '#2B6CB0', color: '#fff', textTransform: "none", borderRadius: "8px", "&:hover": { backgroundColor: '#1a4a8a' } }}>
//                         Choose File
//                         <input type="file" hidden onChange={handleFileUpload} />
//                       </Button>
//                     </Box>
//                     {selectedFile && (
//                       <Typography sx={{ mt: 0.5, fontSize: 12, color: '#555' }}>
//                         Selected: <strong>{selectedFile.name}</strong>
//                       </Typography>
//                     )}
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Remarks</Typography>
//                     <CTSinput type="text" size="small" fullWidth name="remarks"
//                       value={dialogData.remarks} onChange={handleDialogChange}
//                       InputProps={{ className: styles.CTSinput_Box2 }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//                     <Typography sx={fieldLabelSx}>Qty Filled</Typography>
//                     <CTSinput type="number" fullWidth size="small" name="qty_filled"
//                       value={dialogData.qty_filled}
//                       disabled
//                       InputProps={{ className: styles.CTSinput_Box2, readOnly: true }}
//                     />
//                   </Grid>
//                   <Grid item xs={12} sm={6}>
//   <Typography sx={fieldLabelSx}>Topup Qty</Typography>
//   <CTSinput type="number" fullWidth size="small" name="topup_qty"
//     value={dialogData.topup_qty} onChange={handleDialogChange}
//     sx={topupInputSx}
//     InputProps={{ className: styles.CTSinput_Box2 }}
//   />
// </Grid>
//                 </Grid>
//               )}
//             </Grid>
//           </DialogContent>
//           <DialogActions sx={{ px: 3, py: 2 }}>
//             <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
//             <Button onClick={handleDialogSubmit} sx={saveBtnSx}>
//               <SaveIcon sx={{ fontSize: 16 }} /> Done
//             </Button>
//           </DialogActions>
//         </Dialog>

// <Snackbar
//   key={successMessage + severity + Date.now()}   // ✅ force remount, always shows fresh
//   open={openSnackbar}
//   onClose={(e, reason) => { if (reason === 'clickaway') return; setOpenSnackbar(false); }}
//   autoHideDuration={2500}
//   anchorOrigin={{ vertical: "top", horizontal: "right" }}
// >
//   <Alert
//     onClose={() => setOpenSnackbar(false)}
//     severity={severity}
//     variant="filled"
//     sx={{ width: "100%", fontSize: "13px", fontWeight: 600 }}
//   >
//     {successMessage}
//   </Alert>
// </Snackbar>
//       </Box>
//     </LocalizationProvider>
//   );
// };

// export default QualityEntryAdd;


import React, { useEffect, useRef, useState } from "react";
import {
  Box, Button, Paper, Typography, Grid, TableContainer, Table,
  TableHead, TableBody, IconButton, MenuItem, DialogActions,
  DialogTitle, DialogContent, Dialog, TableRow, TableCell,
} from "@mui/material";
import ClearIcon from '@mui/icons-material/Clear';
import { Html5Qrcode } from 'html5-qrcode';
import { useLocation, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import VerifiedIcon from "@mui/icons-material/Verified";
import productMasterService from "../../../services/masters/productMaster.Service";
import cylinderMasterService from "../../../services/masters/cylinderMaster.Service";
import depotMasterService from "../../../services/masters/depotMaster.Service";
import plantMasterService from "../../../services/masters/plantMaster.Service";
import productionentryService from "../../../services/productionentry.Service";
import qualitycontrolService from "../../../services/qualitycontrol.Service";
import uploadFileApi from "../../../services/uploadFile.Service";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ReusableSnackbar from "../../reusableComponent/ReusableSnackbar";
import { CTSinput, StyledTableCell, StyledTableRow } from "../../reusableComponent/Reusables";
import operatorMasterService from "../../../services/masters/operatorMaster.Service";
import styles from "../../../styles.module.css";
import dayjs from "dayjs";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

// ── Styles ────────────────────────────────────────────────────────────────────

const pageSx = {
  background: "#F4F7FB", minHeight: "100vh",
  padding: "20px 24px 40px", fontFamily: "'Inter', Arial, sans-serif",
};
const breadcrumbSx = {
  fontSize: "12px", color: "#718096", mb: 2,
  display: "flex", alignItems: "center", gap: "6px",
};
const pageHeaderSx = {
  display: "flex", alignItems: "center",
  justifyContent: "space-between", mb: 2.5,
};
const pageTitleSx = {
  fontSize: "16px", fontWeight: 700, color: "#000",
  display: "flex", alignItems: "center", gap: "10px",
};
const backBtnSx = {
  display: "flex", alignItems: "center", gap: "6px",
  fontSize: "13px", fontWeight: 600, color: "#2B6CB0",
  padding: "7px 14px", border: "1.5px solid #2B6CB0",
  borderRadius: "7px", background: "#fff", textTransform: "none",
  "&:hover": { background: "#E6F1FB" },
};
const formCardSx = {
  background: "#fff",
  border: "1px solid #E2E8F0", overflow: "hidden", mb: 2,
};
const sectionHeaderSx = {
  background: "#1C3A5E", padding: "12px 22px",
  display: "flex", alignItems: "center", gap: "10px",
};
const sectionHeaderTitleSx = {
  fontSize: "13px", fontWeight: 600, color: "#fff", letterSpacing: "0.3px",
};
const formBodySx = { padding: "22px 24px" };
const fieldLabelSx = {
  fontSize: "12px", fontWeight: 600, color: "#2063b6",
  mb: "4px", display: "flex", alignItems: "center", gap: "4px",
};
const inputSx = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa", height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
    "&.Mui-focused": { background: "#fff" },
    "&.Mui-disabled": { background: "#F8FAFC" },
  },
  "& input": {
    color: "#1A202C", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    "&::placeholder": { color: "#A0AEC0", opacity: 1 },
  },
  "& .MuiInputLabel-root": { display: "none" },
};
const readOnlyInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"], background: "#F0F4F8",
  },
};
const datePickerSx = {
  width: "100%",
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px", fontSize: "13px",
    fontFamily: "'Inter', Arial, sans-serif",
    background: "#fafafa", height: "38px",
    "& fieldset": { borderColor: "#E2E8F0", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#CBD5E0" },
    "&.Mui-focused fieldset": { borderColor: "#2B6CB0", borderWidth: "2px" },
  },
  "& input": { fontSize: "13px", fontFamily: "'Inter', Arial, sans-serif" },
};
const formFooterSx = {
  padding: "18px 24px", background: "#F8FAFC",
  borderTop: "1px solid #E2E8F0",
  display: "flex", alignItems: "center", justifyContent: "flex-end", gap: "10px",
};
const saveBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#4CAF50",
  color: "#fff", border: "none", fontSize: "14px", fontWeight: 600,
  textTransform: "none", borderRadius: "8px",
  "&:hover": { background: "#028b19", transform: "translateY(-1px)" },
  transition: "all 0.15s ease",
};
const cancelBtnSx = {
  display: "flex", alignItems: "center", gap: "7px",
  padding: "0 22px", height: "40px", background: "#E53E3E",
  color: "#fff", border: "none", textTransform: "none",
  "&:hover": { background: "#971f16", transform: "translateY(-1px)" },
  fontSize: "14px", fontWeight: 600, borderRadius: "8px",
};
const tableHeadCellSx = {
  background: "#1C3A5E !important", color: "#fff !important",
  fontSize: "12px", fontWeight: 600,
  fontFamily: "'Inter', Arial, sans-serif", whiteSpace: "nowrap",
};

const topupInputSx = {
  ...inputSx,
  "& .MuiOutlinedInput-root": {
    ...inputSx["& .MuiOutlinedInput-root"],
      borderRadius: 0, 
    background: "#f5bb32",                    // ✅ light yellow highlight
    "& fieldset": { borderColor: "#F0B429", borderWidth: "1.5px" },
    "&:hover fieldset": { borderColor: "#D69E2E" },
    "&.Mui-focused fieldset": { borderColor: "#D69E2E", borderWidth: "2px" },
     "&.Mui-focused": { background: "#F5bb32" }, 
  },
  "& input": {
    ...inputSx["& input"],
    color: "#000000",           // ✅ NEW — full black text
    fontWeight: 600,
  },
};

// ─────────────────────────────────────────────────────────────────────────────

const QualityEntryAdd = () => {
  const login_details = sessionStorage.getItem('loginUser');
  const userD = JSON.parse(login_details);
  const userInfo = userD.result.userInfo;
  const user_role = userD?.result?.userInfo?.user_role;
  const plant_id = userInfo.plant_id;
  const unit_id = userInfo.depot_id || userInfo.plant_id;
  const short_code = userInfo.depot_short_code || userInfo.plant_short_code;
  const depot_id = userInfo.assigned_depot_id;

  const { handleSubmit } = useForm();
  const urlLocation = useLocation();
  const editInfo = urlLocation.state;
  const editData = editInfo && editInfo;
  const editid = editData ? editData.quality_control_id : null;
  let navigate = useNavigate();

  const [data, setData] = useState({
    entry_no: editData ? editData.entry_no : "",
    quality_supervisor: editData ? editData.quality_supervisor : "",
    batch_no: editData ? editData.batch_no : "",
      topup_qty: editData ? editData.topup_qty : "",
    prod_code: editData ? editData.prod_code : "",
    prod_id: editData ? editData.prod_id : "",
    prod_description: editData ? editData.prod_description : "",
    from_plant: editData ? editData.from_plant : "",
    to_depot_id: editData ? editData.to_depot_id : depot_id,
    entry_date: editData?.entry_date
      ? new Date(editData.entry_date).toISOString().split("T")[0]
      : new Date().toISOString().split("T")[0],
    fin_year: editData ? editData.fin_year : "",
    from_plant_id: editData ? editData.from_plant_id || plant_id : plant_id,
    to_plant_id: editData ? editData.to_plant_id || plant_id : plant_id,
    modified_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    modified_by: editData ? userInfo.user_id : null,
    created_at: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    created_by: editData ? editData.created_by : userInfo.user_id,
  });

  const [product, setProduct] = useState([]);
  const [cylinder, setCylinder] = useState([]);
  const [selectedFile, setSelectedFile] = useState(null);
  const [plant, setPlant] = useState([]);
  const [depot, setDepot] = useState([]);
  const [production_entry, setProductionEntry] = useState([]);
  const [relatedCylinders, setRelatedCylinders] = useState([]);
  const [operatorList, setOperatorList] = useState([]);
  const [table_details, setQualityDetails] = useState(
    editData && editData.table_details && Array.isArray(JSON.parse(editData.table_details))
      ? JSON.parse(editData.table_details) : []
  );
  const [openDialog, setOpenDialog] = useState(false);
  const [isMultiDialog, setIsMultiDialog] = useState(false);
  const [dialogData, setDialogData] = useState({
    cyl_no: "", cyl_id: "", tag_no: "", owner: "",qty_filled: "",
     product_purity: "97", settled_pressure: "",topup_qty: "", 
    leak_test: "Ok", quality_result: "Ok", remarks: "", filePath: "",
  });
  const [multiCylinders, setMultiCylinders] = useState([]);
  const [editIndex, setEditIndex] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [severity, setSeverity] = useState("info");
  const [isScannerOpen, setIsScannerOpen] = useState(false);
  const [scanResults, setScanResults] = useState([]);
  const [batchNo, setbatchno] = useState([]);
  const qrCodeRegionId = 'qr-reader';
  const html5QrCodeRef = useRef(null);
  const scannerStateRef = useRef({ isStarting: false, isStopping: false });
  const lastScanTimeRef = useRef(0);
  const debounceDelay = 500;

  const handleCloseDialog = () => {
    stopScanner(); setOpenDialog(false); setScanResults([]);
  };

  useEffect(() => {
    async function fetchData() {
      try {
        const [productData, cylinderData, depotData, plantData, productionEntryData, batchData, relatedCylindersData, operatorData] = await Promise.all([
          
          productMasterService.getProductList({ page: 0, size: 999, searchKey: "" }),
          cylinderMasterService.getCylinderList({ page: 0, size: 999, searchKey: "" }),
          depotMasterService.getDepotList({ page: 0, size: 999, searchKey: "" }),
          plantMasterService.getPlantList({ page: 0, size: 999, searchKey: "" }),
          productionentryService.getProductionEntryList({ page: 0, size: 999, searchKey: "" }),
          qualitycontrolService.getBatchNo({ page: 0, size: 999, searchKey: "" }),
          data.batch_no ? qualitycontrolService.getQualityCylinder(plant_id, data.batch_no) : Promise.resolve([]),
           operatorMasterService.getOperatorList({ page: 0, size: 999, searchKey: "" }),
          
        ]);
        setProduct(productData); setCylinder(cylinderData); setDepot(depotData);
        setPlant(plantData); setProductionEntry(productionEntryData);
        setRelatedCylinders(relatedCylindersData);
        setOperatorList(Array.isArray(operatorData) ? operatorData : []);
        setbatchno(Array.isArray(batchData) ? batchData : (Array.isArray(batchData?.data) ? batchData.data : []));
        if (!editData) {
  const qualityList = await qualitycontrolService.getQualitycontrolList({ page: 0, size: 5, searchKey: "" });
  
  const lastEntryNo = qualityList?.[0]?.entry_no ?? "";
  const parts = String(lastEntryNo).split("/");
  const lastSeq = parseInt(parts[parts.length - 1]) || 0;
  const nextSeq = lastSeq + 1;

  // Short year: "26-27"
  const yr = dayjs();
  const finYear = yr.month() >= 3
    ? `${String(yr.year()).slice(-2)}-${String(yr.year() + 1).slice(-2)}`
    : `${String(yr.year() - 1).slice(-2)}-${String(yr.year()).slice(-2)}`;


  const formattedEntryNo = `QC/${short_code}/${finYear}/${String(nextSeq).padStart(4, "0")}`;

  setData(prev => ({
    ...prev,
    entry_no: formattedEntryNo,
    fin_year: finYear,
  }));
}
      } catch (error) { console.error("Data fetching failed", error); }
    }
    fetchData();
  }, [plant_id, data.batch_no]);

  useEffect(() => {
    if (editData && product.length && editData.prod_id) {
      const foundProduct = product.find((p) => p.prod_id === editData.prod_id);
      let update = {};
      if (foundProduct) { update.prod_code = foundProduct.prod_code; update.prod_description = foundProduct.prod_description; }
      if (editData.from_plant_id && plant.length) {
        const foundPlant = plant.find((p) => p.plant_id === editData.from_plant_id);
        if (foundPlant) { update.from_plant = foundPlant.plant_id; update.quality_supervisor = foundPlant.plant_name; }
      }
      if (Object.keys(update).length > 0) setData((prev) => ({ ...prev, ...update }));
    }
    // 👆 Removed the auto-fill of quality_supervisor with plant_name for new entries —
    // it was silently keeping the field non-empty, so the "required" validation in
    // onSubmit never triggered. Now it stays blank until the user actually picks one
    // from the Quality Supervisor dropdown.
  }, [editData, product, plant, userInfo.plant_name]);

  useEffect(() => {
    if (data.batch_no && relatedCylinders.length > 0) {
      setQualityDetails(relatedCylinders.map((cyl, index) => ({
        sr_no: index + 1, cyl_no: cyl.cylinder_no || "", cyl_id: cyl.cyl_id || "",
        tag_no: cyl.tag_no || "", owner: cyl.owner || "N/A",product_purity: "97",qty_filled: cyl.qty_filled ?? "",  cyl_remark: cyl.cyl_remark || "",
        settled_pressure: cyl.batch_pressure || "", leak_test: "Ok", quality_result: "Ok", remarks: "", filePath: "",
      })));
    }
  }, [relatedCylinders, data.batch_no]);

  useEffect(() => {
  const total = table_details
    .filter(row => parseFloat(row.topup_qty) > 0)
    .reduce((sum, row) => sum + parseFloat(row.topup_qty), 0);
  setData(prev => ({ ...prev, topup_qty: total > 0 ? total.toFixed(2) : "" }));
}, [table_details]);

  const handleChange = ({ target }) => {
    const { name, value } = target;
    if (name === "batch_no") {
      const selectedBatch = batchNo.find(pe => pe.batch_no === value);
      let prod_id = selectedBatch?.prod_id || "";
      let prod_code = "", prod_description = "";
      if (prod_id && product.length) {
        const found = product.find((p) => p.prod_id === prod_id);
        if (found) { prod_code = found.prod_code; prod_description = found.prod_description; }
      }
      setData({ ...data, batch_no: value, prod_id, prod_code, prod_description });
    } else {
      setData(prevData => {
        const updatedData = { ...prevData, [name]: value };
        if (name === "entry_date" && value) {
          const d = new Date(value);
          if (!isNaN(d.getTime())) {
            const m = d.getMonth(), y = d.getFullYear();
            updatedData.fin_year = m >= 3 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
          }
        }
        return updatedData;
      });
    }
  };

  const findRelatedCylinderByNoOrTag = (input) => {
    if (!input) return null;
    const val = input.trim().toLowerCase();
    return relatedCylinders.find(cyl =>
      (cyl.cylinder_no && cyl.cylinder_no.toLowerCase() === val) ||
      (cyl.tag_no && cyl.tag_no.toLowerCase() === val)
    );
  };

  const handleSingleCylinderInput = (input) => {
    const match = findRelatedCylinderByNoOrTag(input);
    if (match) {
      setDialogData({ cyl_no: match.cylinder_no, cyl_id: match.cyl_id, tag_no: match.tag_no, owner: match.cust_name || match.owner || '',qty_filled: match.qty_filled ?? '', cyl_remark: match.cyl_remark || '', product_purity: dialogData.product_purity || '97',settled_pressure: dialogData.settled_pressure || '', leak_test: dialogData.leak_test || 'Ok', quality_result: dialogData.quality_result || 'Ok', remarks: dialogData.remarks || '', filePath: dialogData.filePath || '' });
      setSuccessMessage(`Cylinder ${match.cylinder_no} loaded successfully`); setOpenSnackbar(true);
    } else {
      setDialogData(prev => ({ ...prev, cyl_no: '', cyl_id: '', tag_no: '', owner: '', filePath: '' }));
      setSuccessMessage('No cylinder found'); setOpenSnackbar(true);
    }
  };

  const handleMultiCylinderInput = (input) => {
    const match = findRelatedCylinderByNoOrTag(input);
    if (match) {
      if (multiCylinders.some(c => c.cyl_id === match.cyl_id)) { setSuccessMessage(`Already added`); setOpenSnackbar(true); return; }
      setMultiCylinders(prev => [...prev, { cyl_id: match.cyl_id, cylinder_no: match.cylinder_no, tag_no: match.tag_no, owner: match.cust_name || match.owner || '',qty_filled: match.qty_filled ?? '', cyl_remark: match.cyl_remark || '' }]);
      setSuccessMessage(`Added successfully`); setOpenSnackbar(true);
    } else { setSuccessMessage('No cylinder found'); setOpenSnackbar(true); }
  };

  const handleOpenDialog = () => {
    setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '',leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
    setEditIndex(null); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
  };

  const handleOpenmulDialog = () => {
    setMultiCylinders([]);
    setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '', leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
    setEditIndex(null); setIsMultiDialog(true); setOpenDialog(true); setScanResults([]);
  };

  const uploadFile = async (file, cylId) => {
    if (!(file instanceof File)) throw new Error('Invalid file object');
    const formData = new FormData();
    formData.append('file', file);
    formData.append('filename', cylId ? `${cylId}_${Date.now()}_${file.name}` : `${Date.now()}_${file.name}`);
    formData.append('cyl_id', cylId);
    const result = await uploadFileApi.uploadFile(formData);
    if (!result.filePath) throw new Error('Server did not return a file path');
    return result.filePath;
  };

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    const allowedTypes = ['image/jpeg', 'image/png', 'application/pdf'];
    if (!allowedTypes.includes(file.type)) { setSuccessMessage('Invalid file type.'); setOpenSnackbar(true); return; }
    if (file.size > 5 * 1024 * 1024) { setSuccessMessage('File size exceeds 5MB.'); setOpenSnackbar(true); return; }
    try {
      setSuccessMessage('Uploading...'); setOpenSnackbar(true);
      const filePath = await uploadFile(file, dialogData.cyl_id || '');
      setDialogData((prev) => ({ ...prev, filePath }));
      setSelectedFile({ name: file.name, path: filePath });
      setSuccessMessage('File uploaded successfully'); setOpenSnackbar(true);
    } catch (error) { setSuccessMessage(`Upload error: ${error.message}`); setOpenSnackbar(true); }
  };

const handleDialogSubmit = async () => {
  try {
    if (isMultiDialog) {
      if (multiCylinders.length === 0) { 
        setSuccessMessage('Add at least one cylinder'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return; 
      }

      // ✅ Product Purity mandatory check (multi)
      if (!dialogData.product_purity || dialogData.product_purity.toString().trim() === "") {
        setSuccessMessage('Product Purity is required'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return;
      }

      const newRows = await Promise.all(multiCylinders.map(async (cyl, idx) => {
        if (table_details.some((row) => row.cyl_id === cyl.cyl_id)) return null;
        return {
          sr_no: table_details.length + idx + 1,
          cyl_no: cyl.cylinder_no,
          cyl_id: cyl.cyl_id,
          tag_no: cyl.tag_no,
          owner: cyl.owner,
           qty_filled: cyl.qty_filled ?? '',
           cyl_remark: cyl.cyl_remark || '',
          product_purity: dialogData.product_purity || '',
          settled_pressure: cyl.batch_pressure || dialogData.settled_pressure || '',
          topup_qty: dialogData.topup_qty !== "" && !isNaN(parseFloat(dialogData.topup_qty))
            ? parseFloat(dialogData.topup_qty).toFixed(2)
            : "",
          leak_test: dialogData.leak_test || 'Ok',
          quality_result: dialogData.quality_result || 'Ok',
          remarks: dialogData.remarks || '',
          filePath: dialogData.filePath || ''
        };
      }));
      const validRows = newRows.filter((row) => row !== null);
      if (validRows.length === 0) { 
        setSuccessMessage('All cylinders already added'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return; 
      }
      setQualityDetails((prev) => [...prev, ...validRows]);
      setSuccessMessage('Cylinders added successfully');
      setSeverity("success");
      setOpenSnackbar(true);
    } else {
      if (!dialogData.cyl_id) { 
        setSuccessMessage('No valid cylinder loaded'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return; 
      }

      // ✅ Product Purity mandatory check (single)
      if (!dialogData.product_purity || dialogData.product_purity.toString().trim() === "") {
        setSuccessMessage('Product Purity is required'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return;
      }

      const newRow = {
        sr_no: editIndex !== null ? table_details[editIndex].sr_no : table_details.length + 1,
        cyl_no: dialogData.cyl_no,
        cyl_id: dialogData.cyl_id,
        tag_no: dialogData.tag_no,
        owner: dialogData.owner,
         qty_filled: dialogData.qty_filled ?? '',
         cyl_remark: dialogData.cyl_remark || (editIndex !== null ? table_details[editIndex]?.cyl_remark : '') || '',
        product_purity: dialogData.product_purity || '',
        settled_pressure: dialogData.settled_pressure || '',
        topup_qty: dialogData.topup_qty !== "" && !isNaN(parseFloat(dialogData.topup_qty))   // ✅ ADDED — ye missing tha
          ? parseFloat(dialogData.topup_qty).toFixed(2)
          : "",
        leak_test: dialogData.leak_test || 'Ok',
        quality_result: dialogData.quality_result || 'Ok',
        remarks: dialogData.remarks || '',
        filePath: dialogData.filePath || ''
      };
      
      let wasDuplicate = false;
      setQualityDetails((prev) => {
        if (editIndex !== null) { const updated = [...prev]; updated[editIndex] = newRow; return updated; }
        if (prev.some((row) => row.cyl_id === newRow.cyl_id)) { 
          wasDuplicate = true;
          return prev; 
        }
        return [...prev, newRow];
      });

      if (wasDuplicate) {
        setSuccessMessage('Already added'); 
        setSeverity("error");
        setOpenSnackbar(true); 
        return;
      }
      // setSuccessMessage(editIndex !== null ? 'Cylinder updated successfully' : 'Cylinder added successfully');
      // setSeverity("success");
      // setOpenSnackbar(true);
    }
    setOpenDialog(false); setScanResults([]); setEditIndex(null); setMultiCylinders([]);
    stopScanner(); setSelectedFile(null);
    setDialogData({ cyl_no: '', cyl_id: '', tag_no: '', owner: '', qty_filled: '', product_purity: '', settled_pressure: '', topup_qty: '', leak_test: 'Ok', quality_result: 'Ok', remarks: '', filePath: '' });
  } catch (error) { 
    setSuccessMessage(`Error: ${error.message}`); 
    setSeverity("error");
    setOpenSnackbar(true); 
  }
};

  const handleDialogChange = ({ target }) => {
    const { name, value } = target;
    setDialogData(prev => ({ ...prev, [name]: value }));
  };

   const handleEditRow = (index) => {
    const row = table_details[index];
    setDialogData({ cyl_no: row.cyl_no || '', cyl_id: row.cyl_id || '', tag_no: row.tag_no || '', owner: row.owner || '', qty_filled: row.qty_filled || '', product_purity: row.product_purity || '', settled_pressure: row.settled_pressure || '',topup_qty: row.topup_qty || '', leak_test: row.leak_test || 'Ok', quality_result: row.quality_result || 'Ok', remarks: row.remarks || '', filePath: row.filePath || '' });
    setSelectedFile(row.filePath ? { name: row.filePath.split('/').pop(), path: row.filePath } : null);
    setEditIndex(index); setIsMultiDialog(false); setOpenDialog(true); setScanResults([]);
  };

  const handleRemoveRow = (index) => {
    setQualityDetails(prev => prev.filter((_, i) => i !== index));
  };

  const stopScanner = () => {
    if (scannerStateRef.current.isStopping || !html5QrCodeRef.current) { setIsScannerOpen(false); return; }
    if (!html5QrCodeRef.current.isScanning) { setIsScannerOpen(false); return; }
    scannerStateRef.current.isStopping = true;
    html5QrCodeRef.current.stop().then(() => { html5QrCodeRef.current.clear(); setIsScannerOpen(false); scannerStateRef.current.isStopping = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStopping = false; });
  };

  useEffect(() => {
    if (!isScannerOpen || !openDialog) {
      if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) stopScanner();
      return;
    }
    const element = document.getElementById(qrCodeRegionId);
    if (!element) { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; return; }
    if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning) { scannerStateRef.current.isStarting = false; return; }
    html5QrCodeRef.current = new Html5Qrcode(qrCodeRegionId);
    html5QrCodeRef.current.start({ facingMode: 'environment' }, { fps: 10, qrbox: 250 },
      (decodedText) => {
        const now = Date.now();
        if (now - lastScanTimeRef.current < debounceDelay) return;
        lastScanTimeRef.current = now;
        if (scanResults.includes(decodedText)) return;
        const match = findRelatedCylinderByNoOrTag(decodedText);
        if (match) {
          if (isMultiDialog) handleMultiCylinderInput(decodedText);
          else { handleSingleCylinderInput(decodedText); stopScanner(); }
          setScanResults(prev => [...prev, decodedText]);
        }
      }, () => { }
    ).then(() => { scannerStateRef.current.isStarting = false; })
      .catch(() => { setIsScannerOpen(false); scannerStateRef.current.isStarting = false; });
    return () => {
      if (html5QrCodeRef.current && html5QrCodeRef.current.isScanning && !scannerStateRef.current.isStopping) {
        try { html5QrCodeRef.current.stop(); html5QrCodeRef.current.clear(); } catch (err) { }
      }
    };
  }, [isScannerOpen, openDialog, isMultiDialog]);

  // const onSubmit = async () => {
  //   if (!table_details || table_details.length === 0) { setSuccessMessage("Add at least one cylinder."); setOpenSnackbar(true); return; }
  //   const quality_Data = { ...data, quality_control_id: editid, table_details: JSON.stringify(table_details), changedUpdatedValue: "edit", unit_id, short_code };
  //   try {
  //     if (editData) { await qualitycontrolService.editDeleteQualitycontrol(quality_Data); setSuccessMessage("Updated successfully"); }
  //     else { await qualitycontrolService.addQualitycontrol(quality_Data); setSuccessMessage("Added successfully"); }
  //     setOpenSnackbar(true);
  //     setTimeout(() => navigate(-1), 1000);
  //   } catch (error) { setSuccessMessage(`Error: ${error.message}`); setOpenSnackbar(true); }
  // };

const [isSubmitting, setIsSubmitting] = useState(false);

const onSubmit = async () => {
  if (isSubmitting) return;

  // 👇 Quality Supervisor required — is ke bina save nahi hoga
  if (!data.quality_supervisor || data.quality_supervisor.toString().trim() === "") {
    setSuccessMessage("Please select Quality Supervisor before saving.");
    setSeverity("error");
    setOpenSnackbar(true);
    return;
  }

  if (!table_details || table_details.length === 0) {
    setSuccessMessage("Add at least one cylinder."); 
    setSeverity("error");
    setOpenSnackbar(true); 
    return; 
  }

  // 👇 NAYI LINE — sirf wahi rows lo jinka product_purity bhara hai
// 👇 NAYI LINE — sirf wahi rows lo jinka product_purity bhara hai
  const table_details_filtered = table_details.filter(
    row => row.product_purity && row.product_purity.toString().trim() !== ""
  );

  // Agar kisi bhi row mein Product Purity nahi hai, toh save hi mat hone do
  if (table_details_filtered.length === 0) {
    setSuccessMessage("Please enter Product Purity for at least one cylinder before saving.");
    setSeverity("error");
    setOpenSnackbar(true);
    return;
  }

   setIsSubmitting(true);
  const quality_Data = {
    ...data, 
    quality_control_id: editid,
    table_details: JSON.stringify(table_details_filtered), // 👈 YAHAN table_details ko table_details_filtered kiya
    changedUpdatedValue: "edit", 
    unit_id, 
    short_code 
  };
  try {
    if (editData) { 
      await qualitycontrolService.editDeleteQualitycontrol(quality_Data); 
      setSuccessMessage("Updated successfully"); 
      setSeverity("success");
    } else { 
      await qualitycontrolService.addQualitycontrol(quality_Data); 
      setSuccessMessage("Added successfully"); 
      setSeverity("success");
    }
    setOpenSnackbar(true);
     setTimeout(() => navigate("/productionEntries/list-qe"), 1000); 
  } catch (error) { 
    setSuccessMessage(`Error: ${error.message}`); 
    setSeverity("error");
    setOpenSnackbar(true); 
    setIsSubmitting(false);
  }
};
  const getConditionalStyles = (value) => ({
    '& .MuiSelect-select': { color: value === 'Ok' ? 'green' : value === 'Not Ok' ? '#c52525' : 'inherit' },
    '& .MuiOutlinedInput-notchedOutline': { borderColor: value === 'Ok' ? 'green' : value === 'Not Ok' ? '#c52525' : 'inherit' },
  });

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={pageSx}>

        {/* Breadcrumb */}
        <Box sx={breadcrumbSx}>
          <span>Dashboard</span> / <span style={{ color: "#2B6CB0", fontWeight: 600 }}>Quality Entry</span>
        </Box>

        {/* Page Header */}
        <Box sx={pageHeaderSx}>
          <Box sx={pageTitleSx}>
            <VerifiedIcon sx={{ fontSize: 20, color: "#1C3A5E" }} />
            {editData ? "UPDATE" : "ADD"} QUALITY ENTRY
          </Box>
          <Button onClick={() => navigate(-1)} sx={backBtnSx}>
            <ArrowBackIcon sx={{ fontSize: 16 }} /> Back
          </Button>
        </Box>

        <form onSubmit={handleSubmit(onSubmit)}>

          {/* ── Section 1: Entry Details ── */}
          <Box sx={formCardSx}>
            <Box sx={sectionHeaderSx}>
              <VerifiedIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Quality Entry Details</Typography>
            </Box>
            <Box sx={formBodySx}>
  <Grid container sx={{ border: "1px solid #E2E8F0", borderRadius: "10px", overflow: "hidden" }}>

    {/* LEFT — blank */}
    {/* LEFT — Topup Qty */}
<Grid item xs={12} md={6} sx={{
  p: 2.5,
  borderBottom: { xs: "2px dashed #CBD5E0", md: "none" },
  minHeight: 200,
}}>
  <Grid container spacing={1.5}>
    <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Total Topup Qty</Typography>
  <CTSinput
    type="number"
    size="small"
    fullWidth
    name="topup_qty"
    value={data.topup_qty}
    sx={topupInputSx}
    InputProps={{ 
      readOnly: true,
      className: styles.CTSinput_Box,
      style: { fontWeight: 600 }
    }}
    // placeholder="Auto-calculated from cylinders"
  />
</Grid>
  </Grid>
</Grid>

    {/* RIGHT — all fields */}
    <Grid item xs={12} md={6} sx={{ p: 2.5, background: "#FAFBFC", pl: 3.5 }}>
      <Grid container spacing={1.5}>

        {/* Entry No */}
    <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Entry No</Typography>
  <CTSinput size="small" fullWidth value={data.entry_no} variant="outlined"
    InputProps={{ 
      readOnly: true, 
      className: styles.CTSinput_Box, 
      style: { backgroundColor: "#F0F4F8", fontSize: "13px" } 
    }}
  />
</Grid>

        {/* Entry Date */}
        <Grid item xs={12} sm={6}>
          <Typography sx={fieldLabelSx}>Entry Date <span style={{ color: "#E53E3E" }}>*</span></Typography>
          <DatePicker format="DD/MM/YYYY"
            value={data.entry_date ? dayjs(data.entry_date) : null}
            onChange={(newValue) => handleChange({ target: { name: "entry_date", value: newValue ? newValue.format("YYYY-MM-DD") : "" } })}
            sx={datePickerSx}
            slotProps={{ textField: { size: "small", fullWidth: true, required: true } }}
          />
        </Grid>

        {/* Batch No */}
        <Grid item xs={12} sm={6}>
          <Typography sx={fieldLabelSx}>Batch No</Typography>
          <CTSinput select size="small" fullWidth value={data.batch_no}
            onChange={handleChange} name="batch_no"
            InputProps={{ className: styles.CTSinput_Box }}
          >
            {/* <MenuItem value="" disabled>Select Batch No</MenuItem> */}
            {batchNo.map(entry => (
              <MenuItem key={entry.batch_no} value={entry.batch_no} className={styles.cts_lable}>
                {entry.batch_no}
              </MenuItem>
            ))}
          </CTSinput>
        </Grid>

        {/* Quality Supervisor */}
        <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>
    Quality Supervisor <span style={{ color: "#c52525" }}>*</span>
  </Typography>
  <CTSinput
    select
    size="small"
    fullWidth
    required
    name="quality_supervisor"
    value={data.quality_supervisor || ""}
    onChange={handleChange}
  
    InputProps={{ className: styles.CTSinput_Box }}
  >
    {/* <MenuItem value="" disabled>
      <em style={{ color: "#A0AEC0" }}>Select Supervisor</em>
    </MenuItem> */}
    {operatorList.map((op) => (
      <MenuItem
        key={op.operator_id}
        value={op.operator_name}
        className={styles.cts_lable}
      >
        {op.operator_name}
      </MenuItem>
    ))}
  </CTSinput>
</Grid>

      </Grid>
    </Grid>

  </Grid>
</Box>
          </Box>

          {/* ── Section 2: Cylinder Table ── */}
          <Box sx={formCardSx}>
            {/* <Box sx={sectionHeaderSx}>
              <VerifiedIcon sx={{ fontSize: 18, color: "#fff" }} />
              <Typography sx={sectionHeaderTitleSx}>Cylinder Details</Typography>
            </Box> */}

            <Paper sx={{ width: '100%', boxShadow: "none" }}>
              <TableContainer component={Paper} sx={{ boxShadow: "none", borderRadius: 0 }}>
                <Table size="small" stickyHeader>
                  <TableHead>
                    <StyledTableRow>
                      {["Sr No", "Cyl No", "Tag No", "Owner", "Product Purity", "Settled Pressure","Leak Test", "Quality Result","Qty Filled", "Remarks", "File","Topup Qty","Action"].map((h, i) => (
                        <StyledTableCell key={i} align={i === 0 || i === 10 ? "center" : "left"} sx={tableHeadCellSx}>{h}</StyledTableCell>
                      ))}
                    </StyledTableRow>
                  </TableHead>
                  <TableBody sx={{ backgroundColor: '#fff' }}>
                    {table_details?.map((row, index) => (
                      <StyledTableRow key={row.cyl_id || index} onClick={() => handleEditRow(index)} sx={{ cursor: 'pointer', "&:hover": { background: "#F0F4F8" } }}>
                        <StyledTableCell align="center" sx={{ fontSize: "12px" }}>{index + 1}</StyledTableCell>
                      <StyledTableCell align="left" sx={{ fontSize: "12px" }}>
  {row.cyl_no}
  {row.cyl_remark === 'TOPUP' && (
    <span style={{ color: "#E53E3E", fontSize: "20px", fontWeight: 900, marginLeft: "4px", lineHeight: 1 }}>*</span>
  )}
</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.tag_no}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.owner || 'N/A'}</StyledTableCell>
                          
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.product_purity}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.settled_pressure}</StyledTableCell>

                        <StyledTableCell align="left" sx={{ fontSize: "12px", color: row.leak_test === 'Ok' ? 'green' : '#c52525', fontWeight: 600 }}>{row.leak_test}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px", color: row.quality_result === 'Ok' ? 'green' : '#c52525', fontWeight: 600 }}>{row.quality_result}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.qty_filled || '-'}</StyledTableCell>
                        <StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.remarks}</StyledTableCell>
<StyledTableCell align="left" sx={{ fontSize: "12px" }}>{row.filePath ? row.filePath.split('/').pop() : 'None'}</StyledTableCell>
<StyledTableCell align="center" sx={{ 
  fontSize: "12px", 
  fontWeight: 600, 
 
 
}}>
  {row.topup_qty && parseFloat(row.topup_qty) > 0 ? parseFloat(row.topup_qty).toFixed(2) : 0}
</StyledTableCell>
<StyledTableCell align="center" onClick={e => e.stopPropagation()}>
  <IconButton size="small" onClick={() => handleRemoveRow(index)}>
    <DeleteForeverIcon sx={{ fontSize: "18px", color: "#E53E3E" }} />
  </IconButton>
</StyledTableCell>
                      </StyledTableRow>
                    ))}
                    {(!table_details || table_details.length === 0) && (
                      <StyledTableRow>
                        <StyledTableCell colSpan={13} align="center" sx={{ fontSize: "12px", color: "#718096", py: 3 }}>
                          No cylinders added — select a batch to auto-populate
                        </StyledTableCell>
                      </StyledTableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>

            {/* Footer */}
            <Box sx={formFooterSx}>
              <Button sx={cancelBtnSx} onClick={() => navigate(-1)}>Cancel</Button>
                <Button type="submit" sx={saveBtnSx} disabled={isSubmitting}>
                <SaveIcon sx={{ fontSize: 18 }} />
                {isSubmitting ? "Saving..." : editData ? "Update" : "Save"}
              </Button>
            </Box>
          </Box>

        </form>

        {/* ── Dialog ── */}
        <Dialog open={openDialog} onClose={() => { stopScanner(); setOpenDialog(false); setScanResults([]); setEditIndex(null); }} maxWidth="md" fullWidth
          PaperProps={{ sx: { borderRadius: "14px" } }}>
          <DialogTitle sx={{ background: "#1C3A5E", color: "#fff", fontSize: "14px", fontWeight: 700, py: 1.5 }}>
            {editIndex !== null ? (
              <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                <Typography sx={{ color: "#fff", fontSize: "13px" }}>Cylinder No: {dialogData.cyl_no || 'N/A'}</Typography>
                <Typography sx={{ color: "#fff", fontSize: "13px" }}>Tag No: {dialogData.tag_no || 'N/A'}</Typography>
                <Typography sx={{ color: "#fff", fontSize: "13px" }}>Owner: {dialogData.owner || 'N/A'}</Typography>
              </Box>
            ) : isMultiDialog ? 'Scan Multiple Cylinders' : 'Scan Single Cylinder'}
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Grid container spacing={2} sx={{ pt: 2, justifyContent: 'space-between' }}>
              {isMultiDialog ? (
                <Box sx={{ mt: 2, width: "100%" }}>
                  <TableContainer component={Paper}>
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          {["Sr No", "Owner", "Cylinder No", "Tag No", "Action"].map((h, i) => (
                            <TableCell key={i} sx={{ fontWeight: 700, background: "#1C3A5E", color: "#fff", fontSize: "12px" }}>{h}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {multiCylinders.map((row, idx) => (
                          <TableRow key={row.cyl_id}>
                            <TableCell sx={{ fontSize: "12px" }}>{idx + 1}</TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>{row.owner || 'N/A'}</TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>{row.cylinder_no}</TableCell>
                            <TableCell sx={{ fontSize: "12px" }}>{row.tag_no}</TableCell>
                            <TableCell>
                              <IconButton size="small" onClick={() => setMultiCylinders(prev => prev.filter(c => c.cyl_id !== row.cyl_id))}>
                                <DeleteForeverIcon sx={{ fontSize: '18px', color: '#E53E3E' }} />
                              </IconButton>
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Box>
              ) : (
                <Grid container spacing={2} sx={{ mt: 1, pb: 1, px: 1 }}>
                  <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Product Purity <span style={{ color: "#E53E3E" }}>*</span></Typography>
  <CTSinput type="number" fullWidth size="small" name="product_purity"
    value={dialogData.product_purity} onChange={handleDialogChange}
    InputProps={{ className: styles.CTSinput_Box2 }}
    error={!dialogData.product_purity}
  />
</Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Settled Pressure</Typography>
                    <CTSinput type="number" fullWidth size="small" name="settled_pressure"
                      value={dialogData.settled_pressure} onChange={handleDialogChange}
                      InputProps={{ className: styles.CTSinput_Box2 }}
                    />
                  </Grid>
                  
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Leak Test</Typography>
                    <CTSinput select size="small" fullWidth name="leak_test"
                      value={dialogData.leak_test} onChange={handleDialogChange}
                      sx={getConditionalStyles(dialogData.leak_test)}
                      InputProps={{ className: styles.CTSinput_Box2 }}
                    >
                      <MenuItem value="Ok" sx={{ color: 'green', fontSize: "13px" }}>Ok</MenuItem>
                      <MenuItem value="Not Ok" sx={{ color: 'red', fontSize: "13px" }}>Not Ok</MenuItem>
                    </CTSinput>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Quality Result</Typography>
                    <CTSinput select size="small" fullWidth name="quality_result"
                      value={dialogData.quality_result} onChange={handleDialogChange}
                      sx={getConditionalStyles(dialogData.quality_result)}
                      InputProps={{ className: styles.CTSinput_Box2 }}
                    >
                      <MenuItem value="Ok" sx={{ color: 'green', fontSize: "13px" }}>Ok</MenuItem>
                      <MenuItem value="Not Ok" sx={{ color: 'red', fontSize: "13px" }}>Not Ok</MenuItem>
                    </CTSinput>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Upload File</Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                      <CTSinput size="small" fullWidth value={selectedFile ? selectedFile.name : ''} placeholder="No file chosen"
                        InputProps={{ className: styles.CTSinput_Box2, readOnly: true, endAdornment: selectedFile ? (
                          <IconButton size="small" onClick={() => { setSelectedFile(null); setDialogData(prev => ({ ...prev, filePath: '' })); }} sx={{ color: 'red' }}>
                            <ClearIcon fontSize="small" />
                          </IconButton>
                        ) : null }}
                        sx={{ maxWidth: 260 }}
                      />
                      <Button variant="contained" component="label" size="small"
                        sx={{ minWidth: 120, backgroundColor: '#2B6CB0', color: '#fff', textTransform: "none", borderRadius: "8px", "&:hover": { backgroundColor: '#1a4a8a' } }}>
                        Choose File
                        <input type="file" hidden onChange={handleFileUpload} />
                      </Button>
                    </Box>
                    {selectedFile && (
                      <Typography sx={{ mt: 0.5, fontSize: 12, color: '#555' }}>
                        Selected: <strong>{selectedFile.name}</strong>
                      </Typography>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Remarks</Typography>
                    <CTSinput type="text" size="small" fullWidth name="remarks"
                      value={dialogData.remarks} onChange={handleDialogChange}
                      InputProps={{ className: styles.CTSinput_Box2 }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <Typography sx={fieldLabelSx}>Qty Filled</Typography>
                    <CTSinput type="number" fullWidth size="small" name="qty_filled"
                      value={dialogData.qty_filled}
                      disabled
                      InputProps={{ className: styles.CTSinput_Box2, readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
  <Typography sx={fieldLabelSx}>Topup Qty</Typography>
  <CTSinput type="number" fullWidth size="small" name="topup_qty"
    value={dialogData.topup_qty} onChange={handleDialogChange}
    sx={topupInputSx}
    InputProps={{ className: styles.CTSinput_Box2 }}
  />
</Grid>
                </Grid>
              )}
            </Grid>
          </DialogContent>
          <DialogActions sx={{ px: 3, py: 2 }}>
            <Button onClick={handleCloseDialog} sx={cancelBtnSx}>Cancel</Button>
            <Button onClick={handleDialogSubmit} sx={saveBtnSx}>
              <SaveIcon sx={{ fontSize: 16 }} /> Done
            </Button>
          </DialogActions>
        </Dialog>

<Snackbar
  key={successMessage + severity + Date.now()}   // ✅ force remount, always shows fresh
  open={openSnackbar}
  onClose={(e, reason) => { if (reason === 'clickaway') return; setOpenSnackbar(false); }}
  autoHideDuration={2500}
  anchorOrigin={{ vertical: "top", horizontal: "right" }}
>
  <Alert
    onClose={() => setOpenSnackbar(false)}
    severity={severity}
    variant="filled"
    sx={{ width: "100%", fontSize: "13px", fontWeight: 600 }}
  >
    {successMessage}
  </Alert>
</Snackbar>
      </Box>
    </LocalizationProvider>
  );
};

export default QualityEntryAdd;

